/* eslint-disable no-duplicate-case */
/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";

import { Accordion, AccordionItem } from "@nextui-org/accordion";
import { useState } from "react";
import { ReactComponent as ArrowUpIcon } from "../../assets/icons/caret-double-up.svg";
import SubTicketTable from "./subTicketTable/SubTicketTable";
import TicketCard from "../Ticket/TicketCard";
import CustomTextArea from "../CustomTextArea";
import { TicketPropsInterface } from "../../models/TicketProp";
import {
  stringToTicketPhase,
  stringToTicketStatus,
  TicketPhase,
  TicketStatus,
} from "../../assets/js/AppTicketConstant";
import AppUserProfile, {
  ApproverLevel,
  UserType,
} from "../../assets/js/AppUserProfile";
import { Button, useDisclosure } from "@nextui-org/react";
import SelectApproverModal from "../SelectApproverModal";
import { UpdateProposalTicketStatus } from "../../services/SubmitReviewProposalTicketService";
import RejectSubTicketModal from "../RejectSubTicketModal";
import PrintButton from "./PrintButton";
import ApproverActionButton from "./ApproverActionButton";
import AppUtility from "../../assets/js/AppUtility";
import useSubTicketStore from "../../stores/useSubTicketStore";
import ConfirmApproveModal from "../ConfirmApproveModal";
import useApproverStore from "../../stores/useApproverStore";
import { SubmitClaimReview } from "../../services/SubmitClaimService";
import { SubmitManagemnetReview } from "../../services/SubmitManagementReviewService";
import { SubmitAccountingReview } from "../../services/SubmitAccountingReviewService";
import useTicketStore from "../../stores/useTicketStore";
import { getCurrentUserId } from "../../utils/acl";
import TargetTable from "../Ticket/TargetTable";
import { TicketBrands } from "../../models/TicketBrands";
import dayjs from "dayjs";

const ApproverTicketTile = ({ ticketData }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState(new Set([]));
  const userRole = AppUserProfile.getData()["role_name"];
  const userId = AppUserProfile.getData()["user_id"];
  const userRoleLevel = AppUserProfile.getData()["role_level"];
  const isAdmin = AppUserProfile.getData()["whoami"] === UserType.ADMIN;

  const [isTicketV2, setIsTicketV2] = useState(false);
  const [isSkipApproverValidate, setIsSkipApproverValidate] = useState(false);

  const {
    isOpen: isProposalApproverModalOpen,
    onOpenChange: onProposalApproverModalOpenChange,
  } = useDisclosure();

  const {
    isOpen: isClaimApproverModalOpen,
    onOpenChange: onClaimApproverModalOpenChange,
  } = useDisclosure();

  const { isOpen: isRejectModalOpen, onOpenChange: onRejectModalOpenChange } =
    useDisclosure();

  const {
    isOpen: isRejectAllModalOpen,
    onOpenChange: onRejectAllModalOpenChange,
  } = useDisclosure();

  const { isOpen: isConfirmModalOpen, onOpenChange: onConfirmModalOpenChange } =
    useDisclosure();

  const {
    isOpen: isConfirmSubmitModalOpen,
    onOpenChange: onConfirmSubmitModalOpenChange,
  } = useDisclosure();

  const [selectSubTicket, setSelectSubTicket] = useState([]);

  const handleCollapse = () => {
    setSelectedKeys(new Set([]));
    setIsExpanded(false);
  };

  const { fetchTicketById, getTicketDetailById } = useTicketStore();

  const {
    setReviewTicket,
    areAllProposalTicketsSelected,
    areAllClaimTicketsSelected,
    areAllManagementTicketsSelected,
    areAllAccountingTicketsSelected,
    hasRejectedSubTicket,
  } = useSubTicketStore();

  const { setSelectApprover, findApproverWithConfig } = useApproverStore();

  const { findAssignApprover } = useTicketStore();

  const [carInfos, setCarInfos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (carInfos.length > 0) {
      setIsExpanded(true);
    }
  }, [carInfos]);

  useEffect(() => {
    ticketData.sub_tickets.map((subTicket) => {
      if (stringToTicketStatus(subTicket.status) === TicketStatus.Approved) {
        const review = {
          sub_ticket_id: Number(subTicket.id),
          description: "",
          status: "APPROVED",
        };
        setReviewTicket({
          phase: ticketData.phase,
          subTicketId: Number(subTicket.id),
          data: review,
        });
      }
    });

    setIsTicketV2(dayjs(ticketData.created_at) > dayjs("2025-08-31"));
  }, [ticketData]);

  const handleAcceptProposalTicket = async () => {
    const reviewPayload = ticketData.sub_tickets.map(
      (item) => useSubTicketStore.getState().proposalSubTickets[item.id]
    );

    const createProposalSequencePayload = (level) => {
      let sequencePayload = {
        proposal_phase_sequence_no: null,
        claim_phase_sequence_no: null,
      };

      switch (ticketData.brand) {
        case TicketBrands.BYD:
          if (userRole === ApproverLevel.APPROVER_L1) {
            sequencePayload.proposal_phase_sequence_no =
              level === ApproverLevel.APPROVER_L2 ? 2 : 3;
          } else if (userRole == ApproverLevel.APPROVER_L2) {
            sequencePayload.proposal_phase_sequence_no = 3;
          } else if (userRole == ApproverLevel.APPROVER_L3) {
            sequencePayload.claim_phase_sequence_no = 1;
          }
          break;
        case TicketBrands.Denza:
          if (userRole === ApproverLevel.APPROVER_L1) {
            sequencePayload.proposal_phase_sequence_no = 2;
          } else if (userRole == ApproverLevel.APPROVER_L3) {
            sequencePayload.claim_phase_sequence_no = 1;
          }
          break;
      }

      return sequencePayload;
    };

    const approverObjects = Array.from(
      useApproverStore.getState().selectApprovers.entries()
    ).map(([level, approverData]) => ({
      user_id:
        userRole === ApproverLevel.APPROVER_L1
          ? Number(approverData.id)
          : userRole === ApproverLevel.APPROVER_L2
          ? Number(userId)
          : "",
      level:
        userRole === ApproverLevel.APPROVER_L1
          ? level
          : userRole === ApproverLevel.APPROVER_L2
          ? userRole
          : "",
      ...createProposalSequencePayload(level),
    }));

    await UpdateProposalTicketStatus({
      ticketId: ticketData.id,
      review: reviewPayload,
      approver: isSkipApproverValidate ? null : approverObjects,
      isSkipValidateApprover: isSkipApproverValidate,
      isTicketV2: isTicketV2,
    });
  };

  const handleRejectProposalTicket = async () => {
    const storeTickets = useSubTicketStore.getState().proposalSubTickets;

    const hasReject = hasRejectedSubTicket({
      ticketDataArray: ticketData.sub_tickets,
      phase: TicketPhase.Proposal,
    });

    if (hasReject) {
      const reviewPayload = ticketData.sub_tickets.map(
        (item) => storeTickets[item.id]
      );

      await UpdateProposalTicketStatus({
        ticketId: ticketData.id,
        review: reviewPayload,
        approver: [],
        isTicketV2: isTicketV2,
      });
    }
  };

  const handleRejectClaimTicket = async () => {
    const storeTickets = useSubTicketStore.getState().claimSubTickets;

    const hasReject = hasRejectedSubTicket({
      ticketDataArray: ticketData.sub_tickets,
      phase: TicketPhase.Claim,
    });

    if (hasReject) {
      const reviewPayload = ticketData.sub_tickets.map(
        (item) => storeTickets[item.id]
      );

      await SubmitClaimReview({
        ticketId: ticketData.id,
        bodyPayload: { reviews: reviewPayload },
        isTicketV2: isTicketV2,
      });
    }
  };

  const handleL1AcceptClaimTicket = async () => {
    const sequencePayload = {
      proposal_phase_sequence_no: null,
      claim_phase_sequence_no: null,
      management_phase_sequence_no: null,
      accounting_phase_sequence_no: null,
    };

    const getExistingApprover = (userId) =>
      ticketData.approvers.find(
        (existingApprover) => existingApprover.user_id === userId
      );

    const getExistingSequences = (existingApprover) => {
      if (!existingApprover) return {};

      const sequenceKeys = [
        "proposal_phase_sequence_no",
        "claim_phase_sequence_no",
        "management_phase_sequence_no",
        "accounting_phase_sequence_no",
      ];

      return sequenceKeys.reduce((acc, key) => {
        if (existingApprover[key] !== null) {
          acc[key] = existingApprover[key];
        }
        return acc;
      }, {});
    };

    const approverConfigs = [
      ...(ticketData.brand === TicketBrands.BYD
        ? [
            {
              key: "APPROVER_L2",
              defaultSequence: {
                claim_phase_sequence_no: 2,
              },
            },
          ]
        : []),
      {
        key: "APPROVER_L3",
        defaultSequence: {
          proposal_phase_sequence_no:
            ticketData.brand === TicketBrands.Denza ? 2 : 3,
          claim_phase_sequence_no:
            ticketData.brand === TicketBrands.Denza ? 2 : 3,
        },
      },
      {
        key: "APPROVER_L4",
        defaultSequence: {
          management_phase_sequence_no: 1,
          accounting_phase_sequence_no: 1,
        },
      },
      {
        key: "APPROVER_L5",
        defaultSequence: {
          management_phase_sequence_no: 2,
          accounting_phase_sequence_no: null,
        },
      },
    ];

    const reviewPayload = ticketData.sub_tickets.map(
      (item) => useSubTicketStore.getState().claimSubTickets[item.id]
    );

    const approverStore = useApproverStore.getState();

    const approvers = approverConfigs.map(({ key, defaultSequence }) => {
      const approver = approverStore.selectApprovers.get(key);

      const existingApprover = getExistingApprover(approver.id);
      const existingSequences = getExistingSequences(existingApprover);

      return {
        ...(existingApprover && { id: existingApprover.id }),
        user_id: approver.id,
        level: approver.role_name,
        ...sequencePayload,
        ...defaultSequence,
        ...existingSequences,
      };
    });

    const { existingApprovers, newApprovers } = approvers.reduce(
      (acc, approver) => {
        const exists = getExistingApprover(approver.user_id);
        if (exists) {
          acc.existingApprovers.push(approver);
        } else {
          const exL2Approver = ticketData.approvers.find(
            (approver) => approver.level === "APPROVER_L2"
          );
          let newL2Approver =
            approver.level === "APPROVER_L2" ? approver : null;
          if (
            newL2Approver?.level === "APPROVER_L2" &&
            newL2Approver?.user_id != exL2Approver?.user_id
          ) {
            acc.existingApprovers.push(exL2Approver);
          }
          acc.newApprovers.push(approver);
        }
        return acc;
      },
      { existingApprovers: [], newApprovers: [] }
    );

    const l1Approver = ticketData.approvers.find(
      (approver) => approver.level === "APPROVER_L1"
    );

    const l1UpdatePayload = l1Approver
      ? {
          id: l1Approver.id,
          user_id: l1Approver.user_id,
          level: l1Approver.level,
          ...sequencePayload,
          // accounting_phase_sequence_no: 1,
          ...getExistingSequences(l1Approver),
        }
      : null;

    const finalExistingApprovers = l1UpdatePayload
      ? [...existingApprovers, l1UpdatePayload]
      : existingApprovers;

    await SubmitClaimReview({
      ticketId: ticketData.id,
      bodyPayload: {
        to_create_approvers: newApprovers,
        to_update_approvers: finalExistingApprovers,
        reviews: reviewPayload,
      },
      isTicketV2: isTicketV2,
    });
  };

  const handleAcceptClaimTicket = async () => {
    const reviewPayload = ticketData.sub_tickets.map(
      (item) => useSubTicketStore.getState().claimSubTickets[item.id]
    );

    await SubmitClaimReview({
      ticketId: ticketData.id,
      bodyPayload: {
        reviews: reviewPayload,
      },
      isSkipValidateApprover: isSkipApproverValidate,
      isTicketV2: isTicketV2,
    });
  };

  const handleAcceptManagementTicket = async () => {
    const reviewPayload = ticketData.sub_tickets.map(
      (item) => useSubTicketStore.getState().managementSubTicket[item.id]
    );

    await SubmitManagemnetReview({
      ticketId: ticketData.id,
      review: reviewPayload,
    });
  };

  const findSubTicketById = (data) => {
    return ticketData.sub_tickets.find((item) => data.id.data === item.id);
  };

  const handleAcceptAccountingTicket = async () => {
    await SubmitAccountingReview({ ticketId: ticketData.id });
  };

  const canSubmitTicket = () => {
    const subTickets = ticketData.sub_tickets;

    const isAbleRoleAction =
      ticketData.next_approver_user_id === Number(userId);

    const isValidStatus =
      ticketData.status !== TicketStatus.Rejected.value &&
      ticketData.status !== TicketStatus.Approved.value &&
      ticketData.status !== TicketStatus.Cancelled.value;

    switch (stringToTicketPhase(ticketData.phase)) {
      case TicketPhase.Claim:
        return isAbleRoleAction && areAllClaimTicketsSelected(subTickets);
      case TicketPhase.Proposal:
        return isAbleRoleAction && areAllProposalTicketsSelected(subTickets);
      case TicketPhase.Management:
        return isAbleRoleAction && areAllManagementTicketsSelected(subTickets);
      case TicketPhase.Accounting:
        return (
          isAbleRoleAction &&
          areAllAccountingTicketsSelected(subTickets) &&
          isValidStatus
        );
      default:
        break;
    }
  };

  const onSubmitApprove = async () => {
    switch (userRole) {
      case ApproverLevel.APPROVER_L1:
        switch (stringToTicketPhase(ticketData.phase)) {
          case TicketPhase.Proposal: {
            if(isTicketV2){
              onConfirmSubmitModalOpenChange();
            }
            else{
              const hasReject = hasRejectedSubTicket({
                ticketDataArray: ticketData.sub_tickets,
                phase: TicketPhase.Proposal,
              });
              if (hasReject) {
                onConfirmSubmitModalOpenChange();
              } else {
                const ticketDetail = getTicketDetailById(ticketData.id);
                const isAlreadyHaveL2 = ticketDetail.approvers.some(
                  (approver) => approver.proposal_phase_sequence_no === 2
                );
                if (isAlreadyHaveL2) {
                  let l2Approver = ticketDetail.approvers.find(
                    (approver) => approver.proposal_phase_sequence_no === 2
                  );
                  l2Approver = useApproverStore
                    .getState()
                    .findApproverInStore(l2Approver.level, l2Approver.user_id);

                  setSelectApprover({
                    approver: { [l2Approver.role_name]: l2Approver },
                  });
                  setIsSkipApproverValidate(true);
                  onConfirmSubmitModalOpenChange();
                } else {
                  onProposalApproverModalOpenChange();
                }
              }
            }

            break;
          }
          case TicketPhase.Claim: {
            const hasReject = hasRejectedSubTicket({
              ticketDataArray: ticketData.sub_tickets,
              phase: TicketPhase.Claim,
            });

            if (hasReject) {
              onConfirmSubmitModalOpenChange();
            } else {
              const ticketDetail = getTicketDetailById(ticketData.id);
              const assignApprover = () => {
                switch (ticketData.brand) {
                  case TicketBrands.BYD:
                    return "allPhase";
                  case TicketBrands.Denza:
                    return "allPhase_Denza";
                }
              };

              const isAlreadyApprover = findAssignApprover(ticketData.id, {
                type: assignApprover(),
              });

              if (isAlreadyApprover) {
                const allApprover = findApproverWithConfig(ticketDetail);
                setSelectApprover({
                  approver: allApprover.map((approver) => {
                    return { [approver.role_name]: approver };
                  }),
                });
                setIsSkipApproverValidate(true);
                onConfirmSubmitModalOpenChange();
              } else {
                onClaimApproverModalOpenChange();
              }
            }
            break;
          }
          case TicketPhase.Accounting:
            onConfirmSubmitModalOpenChange();
            break;
        }

        break;
      case ApproverLevel.APPROVER_L2:
      case ApproverLevel.APPROVER_L3:
      case ApproverLevel.APPROVER_L4:
      case TicketPhase.Accounting:
        onConfirmSubmitModalOpenChange();
        break;
      case ApproverLevel.APPROVER_L5:
        switch (stringToTicketPhase(ticketData.phase)) {
          case TicketPhase.Proposal:
          case TicketPhase.Claim:
          case TicketPhase.Management:
            onConfirmSubmitModalOpenChange();
            break;
        }
        break;

      default:
        break;
    }
  };

  const handleSetReviewAllTicket = () => {
    ticketData.sub_tickets.map((item) => {
      const review = {
        sub_ticket_id: Number(item.id),
        description: "",
        status: "APPROVED",
      };

      setReviewTicket({
        phase: ticketData.phase,
        subTicketId: Number(item.id),
        data: review,
      });
    });
  };

  const approveSelectTicket = ({ data }) => {
    const targetSubTicket = findSubTicketById(data);
    setSelectSubTicket([targetSubTicket, ...selectSubTicket]);
    onConfirmModalOpenChange();
  };

  const isDisableRoleAction = () => {
    const isInvalidApprover =
      ticketData.next_approver_user_id !== Number(userId);
    const isInvalidStatus =
      ticketData.status === TicketStatus.Rejected.value ||
      ticketData.status === TicketStatus.Approved.value ||
      ticketData.status === TicketStatus.Cancelled.value;

    return isInvalidApprover || isInvalidStatus;
  };

  const getProposalApproverOptions = () => {
    switch (ticketData.brand) {
      case TicketBrands.Denza:
        return ["APPROVER_L3"];
      case TicketBrands.BYD:
      default:
        return ["APPROVER_L2", "APPROVER_L3"];
    }
  };

  const getClaimApproverOptions = () => {
    switch (ticketData.brand) {
      case TicketBrands.Denza:
        return ["APPROVER_L3", "APPROVER_L4", "APPROVER_L5"];
      case TicketBrands.BYD:
      default:
        return ["APPROVER_L2", "APPROVER_L3", "APPROVER_L4", "APPROVER_L5"];
    }
  };

  return (
    <>
      <Accordion
        selectedKeys={selectedKeys}
        onSelectionChange={async (keys) => {
          setSelectedKeys(keys);
          setIsExpanded(keys.size === 1);
          if (keys.size === 1) {
            setIsLoading(true);
            await fetchTicketById(ticketData.id);
            const ticketDetail = getTicketDetailById(ticketData.id);

            if (ticketDetail?.ticket_car_infos?.length > 0) {
              const initialCarInfo = ticketDetail.ticket_car_infos.map(
                (info) => ({
                  name: info.car_model_name,
                  expectedCustomerAmount: info.expected_customer_amount,
                  expectedReservedAmount: info.expected_reserved_amount,
                  actualCustomerAmount: info.actual_customer_amount,
                  actualReservedAmount: info.actual_reserved_amount,
                })
              );
              setCarInfos(initialCarInfo);
            } else {
              setCarInfos([]);
            }
            setIsLoading(false);
          }
        }}
        variant="spiltted"
      >
        <AccordionItem
          title={<TicketCard isExpanded={isExpanded} ticketData={ticketData} />}
          textValue={" "}
          classNames={{
            title: "bg-white text-black font-bold w-full",
            content: "bg-white px-5 rounded-b-3xl",
            base: "border-none",
            trigger: `bg-white flex justify-between p-3 lg:p-5 ${
              isExpanded ? "rounded-t-3xl" : "rounded-3xl"
            }`,
          }}
          indicator={() => <></>}
        >
          <div className="px-4">
            <hr className="border-t border-black pb-4" />
            <div className="flex flex-col gap-y-2 pb-4">
              <p className="font-semibold">รายละเอียด</p>
              <CustomTextArea isDisabled value={ticketData.description} />
            </div>
            <div>
              {!isLoading && (
                <div className="pb-10">
                  <TargetTable initialData={carInfos} />
                </div>
              )}
            </div>
            <div className="p-4 flex flex-col gap-y-4 items-end bg-light-gray-600 rounded-3xl">
              <SubTicketTable
                id={ticketData.id}
                ticketPhase={stringToTicketPhase(ticketData.phase)}
                ticketStatus={stringToTicketStatus(ticketData.status)}
                ticketSequenceApproved={{
                  last_approver_sequence_no:
                    ticketData.last_approver_sequence_no,
                  next_approver_level: ticketData.next_approver_level,
                  next_approver_sequence_no:
                    ticketData.next_approver_sequence_no,
                  next_approver_user_id: ticketData.next_approver_user_id,
                }}
                columns={[
                  {
                    name: "สถานะ",
                    key: "status",
                  },
                  {
                    name: "เลขที่คำขอ",
                    key: "code",
                  },
                  {
                    name: "ชื่อค่าใช้จ่าย",
                    key: "name",
                  },
                  {
                    name: (
                      <div className="leading-relaxed">
                        งบขอจัดกิจกรรม
                        <br />
                        จำนวนเงินก่อน VAT
                      </div>
                    ),
                    key: "proposal_amount",
                  },

                  ...(stringToTicketPhase(ticketData.phase) !==
                  TicketPhase.Proposal
                    ? [
                        {
                          name: (
                            <div className="leading-relaxed">
                              งบขอเบิกจ่าย
                              <br />
                              จำนวนเงินก่อน VAT
                            </div>
                          ),
                          key: "claim_amount",
                        },
                      ]
                    : []),
                  {
                    name: "รายละเอียด",
                    key: "description",
                  },
                  {
                    name: "ไฟล์คำขออนุมัติ",
                    key: "proposal_file_urls",
                  },
                  ...(stringToTicketPhase(ticketData.phase) !==
                  TicketPhase.Proposal
                    ? [
                        {
                          name: "ไฟล์คำขอทำจ่าย",
                          key: "claim_file_urls",
                        },
                      ]
                    : []),
                  {
                    name: "Action",
                    key: "action",
                  },
                ]}
                data={ticketData.sub_tickets.map((subTicket) => {
                  const baseValue = {
                    id: {
                      data: subTicket.id,
                    },
                    status: {
                      data: subTicket.status,
                      className: "w-[5%] ",
                    },
                    code: {
                      data: `# ${subTicket.code}`,
                      className: "w-[5%] text-nowrap",
                    },
                    name: {
                      data: subTicket.name,
                      className: "w-[10%] text-nowrap",
                    },
                    description: {
                      data: subTicket.description,
                      className: "w-[30%] text-nowrap",
                    },
                    proposal_file_urls: {
                      data: subTicket.proposal_file_urls,
                      className: "w-[30%]",
                    },
                    proposal_amount: {
                      data: subTicket.proposal_amount,
                      className: "w-[5%] ",
                    },
                    action: {
                      data: subTicket.status,
                    },
                  };

                  if (
                    stringToTicketPhase(ticketData.phase) !==
                    TicketPhase.Proposal
                  ) {
                    baseValue.claim_file_urls = {
                      data: subTicket.claim_file_urls || [],
                      className: "w-[30%] ",
                    };
                    baseValue.claim_amount = {
                      data: subTicket.claim_amount || 0,
                      className: "w-[5%]",
                    };
                  }

                  return {
                    value: baseValue,
                    key: subTicket.id,
                  };
                })}
                actions={(() => {
                  switch (userRole) {
                    case ApproverLevel.APPROVER_L1:
                      switch (stringToTicketPhase(ticketData.phase)) {
                        case TicketPhase.Proposal:
                          return {
                            approve: {
                              onPress: (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                            reject: {
                              onPress: (data) => {
                                const targetSubTicket = findSubTicketById(data);
                                onRejectModalOpenChange();
                                setSelectSubTicket([
                                  targetSubTicket,
                                  ...selectSubTicket,
                                ]);
                              },
                            },
                          };
                        case TicketPhase.Claim:
                          return {
                            approve: {
                              onPress: (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                            reject: {
                              onPress: (data) => {
                                const targetSubTicket = findSubTicketById(data);
                                onRejectModalOpenChange();
                                setSelectSubTicket([
                                  targetSubTicket,
                                  ...selectSubTicket,
                                ]);
                              },
                            },
                          };
                        case TicketPhase.Accounting:
                          return {
                            paid: {
                              onPress: (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                          };
                        default:
                          return null;
                      }
                    case ApproverLevel.APPROVER_L2:
                      switch (stringToTicketPhase(ticketData.phase)) {
                        case TicketPhase.Proposal:
                          return {
                            approve: {
                              onPress: async (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                            reject: {
                              onPress: (data) => {
                                const targetSubTicket = findSubTicketById(data);
                                onRejectModalOpenChange();
                                setSelectSubTicket([
                                  targetSubTicket,
                                  ...selectSubTicket,
                                ]);
                              },
                            },
                          };
                        case TicketPhase.Claim:
                          return {
                            approve: {
                              onPress: async (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                            reject: {
                              onPress: (data) => {
                                const targetSubTicket = findSubTicketById(data);
                                onRejectModalOpenChange();
                                setSelectSubTicket([
                                  targetSubTicket,
                                  ...selectSubTicket,
                                ]);
                              },
                            },
                          };
                        default:
                          return null;
                      }

                    case ApproverLevel.APPROVER_L3:
                      switch (stringToTicketPhase(ticketData.phase)) {
                        case TicketPhase.Proposal:
                          return {
                            approve: {
                              onPress: async (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                            reject: {
                              onPress: (data) => {
                                const targetSubTicket = findSubTicketById(data);
                                onRejectModalOpenChange();
                                setSelectSubTicket([
                                  targetSubTicket,
                                  ...selectSubTicket,
                                ]);
                              },
                            },
                          };
                        case TicketPhase.Claim:
                          return {
                            approve: {
                              onPress: async (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                            reject: {
                              onPress: (data) => {
                                const targetSubTicket = findSubTicketById(data);
                                onRejectModalOpenChange();
                                setSelectSubTicket([
                                  targetSubTicket,
                                  ...selectSubTicket,
                                ]);
                              },
                            },
                          };
                        default:
                          return null;
                      }
                    case ApproverLevel.APPROVER_L4:
                      switch (stringToTicketPhase(ticketData.phase)) {
                        case TicketPhase.Management:
                          return {
                            approve: {
                              onPress: async (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                            reject: {
                              onPress: (data) => {
                                const targetSubTicket = findSubTicketById(data);
                                onRejectModalOpenChange();
                                setSelectSubTicket([
                                  targetSubTicket,
                                  ...selectSubTicket,
                                ]);
                              },
                            },
                          };
                        case TicketPhase.Accounting:
                          return {
                            paid: {
                              onPress: (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                          };
                        default:
                          return null;
                      }
                    case ApproverLevel.APPROVER_L5:
                      switch (stringToTicketPhase(ticketData.phase)) {
                        case TicketPhase.Management:
                          return {
                            approve: {
                              onPress: async (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                            reject: {
                              onPress: (data) => {
                                const targetSubTicket = findSubTicketById(data);
                                onRejectModalOpenChange();
                                setSelectSubTicket([
                                  targetSubTicket,
                                  ...selectSubTicket,
                                ]);
                              },
                            },
                          };
                        default:
                          return null;
                      }
                    case UserType.BUSINESS_CONTROL: {
                      switch (stringToTicketPhase(ticketData.phase)) {
                        case TicketPhase.Proposal:
                          return {
                            approve: {
                              onPress: (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                            reject: {
                              onPress: (data) => {
                                const targetSubTicket = findSubTicketById(data);
                                onRejectModalOpenChange();
                                setSelectSubTicket([
                                  targetSubTicket,
                                  ...selectSubTicket,
                                ]);
                              },
                            },
                          };
                        case TicketPhase.Claim:
                          return {
                            approve: {
                              onPress: (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                            reject: {
                              onPress: (data) => {
                                const targetSubTicket = findSubTicketById(data);
                                onRejectModalOpenChange();
                                setSelectSubTicket([
                                  targetSubTicket,
                                  ...selectSubTicket,
                                ]);
                              },
                            },
                          };
                        case TicketPhase.Management:
                          return {
                            approve: {
                              onPress: async (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                            reject: {
                              onPress: (data) => {
                                const targetSubTicket = findSubTicketById(data);
                                onRejectModalOpenChange();
                                setSelectSubTicket([
                                  targetSubTicket,
                                  ...selectSubTicket,
                                ]);
                              },
                            },
                          };
                        case TicketPhase.Accounting:
                          return {
                            paid: {
                              onPress: (data) => {
                                approveSelectTicket({ data: data });
                              },
                            },
                          };
                        default:
                          return null;
                      }
                    }

                    default:
                      break;
                  }
                })()}
              />

              <div className="flex gap-x-2">
                {ApproverActionButton({
                  ticketPhase: ticketData.phase,
                  ticketStatus: ticketData.status,
                  onApproveAll: async () => {
                    setSelectSubTicket(ticketData.sub_tickets);
                    handleSetReviewAllTicket();
                  },
                  ticketSequenceApproved: {
                    last_approver_sequence_no:
                      ticketData.last_approver_sequence_no,
                    next_approver_level: ticketData.next_approver_level,
                    next_approver_sequence_no:
                      ticketData.next_approver_sequence_no,
                    next_approver_user_id: ticketData.next_approver_user_id,
                  },
                })}
                {stringToTicketPhase(ticketData.phase) !=
                TicketPhase.Accounting ? (
                  <Button
                    isDisabled={isDisableRoleAction()}
                    className="bg-error text-white"
                    onPress={onRejectAllModalOpenChange}
                  >
                    ไม่อนุมัติทั้งหมด
                  </Button>
                ) : (
                  <></>
                )}
              </div>
            </div>

            <div className="grid lg:grid-cols-3 py-5 w-full gap-4">
              <div className="flex justify-center lg:justify-start">
                <PrintButton />
              </div>
              <div className="flex justify-center">
                <Button
                  className="flex justify-center bg-white hover:bg-gray-50 transition-colors"
                  isIconOnly
                  onPress={() => {
                    handleCollapse();
                  }}
                >
                  <ArrowUpIcon className="p-2" />
                </Button>
              </div>
              <div className="flex justify-center lg:justify-end">
                <Button
                  className="bg-blue-500 text-white"
                  onPress={() => {
                    onSubmitApprove();
                  }}
                  isDisabled={!canSubmitTicket()}
                >
                  ยืนยันการส่งคำขอ
                </Button>
              </div>
            </div>
          </div>
        </AccordionItem>
      </Accordion>
      <SelectApproverModal
        isOpen={isProposalApproverModalOpen}
        isSeperateRole={true}
        onOpenChange={onProposalApproverModalOpenChange}
        roles={getProposalApproverOptions()}
        onConfirm={(data) => {
          setSelectApprover({ approver: data });
          onProposalApproverModalOpenChange();
          onConfirmSubmitModalOpenChange();
        }}
      />

      <SelectApproverModal
        isOpen={isClaimApproverModalOpen}
        isSeperateRole={true}
        onOpenChange={onClaimApproverModalOpenChange}
        roles={getClaimApproverOptions()}
        onConfirm={async (data) => {
          setSelectApprover({ approver: data });
          onClaimApproverModalOpenChange();
          onConfirmSubmitModalOpenChange();
        }}
      />

      <RejectSubTicketModal
        isOpen={isRejectModalOpen}
        onOpenChange={onRejectModalOpenChange}
        adjustAmount={{
          isAdjustable: true,
          proposalAmount:
            stringToTicketPhase(ticketData.phase) === TicketPhase.Proposal
              ? selectSubTicket?.[0]?.proposal_amount
              : selectSubTicket?.[0]?.claim_amount,
        }}
        onConfirm={(rejectReason) => {
          const targetSubTicket = selectSubTicket[0];
          const reviewObject = {
            sub_ticket_id: Number(targetSubTicket.id),
            description: rejectReason.rejectReason,
            adjusted_amount: Number(rejectReason.claimAmount),
            status: "REJECTED",
          };
          setReviewTicket({
            phase: ticketData.phase,
            subTicketId: Number(targetSubTicket.id),
            data: reviewObject,
          });
          onRejectModalOpenChange();
        }}
      />

      <RejectSubTicketModal
        isOpen={isRejectAllModalOpen}
        adjustAmount={{
          isAdjustable: false,
        }}
        onOpenChange={onRejectAllModalOpenChange}
        onConfirm={(rejectReason) => {
          ticketData.sub_tickets.map((item) => {
            const review = {
              sub_ticket_id: Number(item.id),
              description: rejectReason.rejectReason,
              status: "REJECTED",
            };
            setReviewTicket({
              phase: ticketData.phase,
              subTicketId: Number(item.id),
              data: review,
            });
          });
          onRejectAllModalOpenChange();
        }}
      />

      <ConfirmApproveModal
        title={`ยืนยันการอนุมัติ ${selectSubTicket?.[0]?.name ?? ""}`}
        isOpen={isConfirmModalOpen}
        onOpenChange={onConfirmModalOpenChange}
        onConfirm={() => {
          const targetSubTicket = selectSubTicket[0];
          const reviewObject = {
            sub_ticket_id: Number(targetSubTicket.id),
            description: "",
            status: "APPROVED",
          };

          setReviewTicket({
            phase: ticketData.phase,
            subTicketId: Number(targetSubTicket.id),
            data: reviewObject,
          });
          onConfirmModalOpenChange();
        }}
      />

      <ConfirmApproveModal
        title={`ยืนยันการส่ง ${ticketData?.project_name ?? ""}`}
        isOpen={isConfirmSubmitModalOpen}
        onOpenChange={onConfirmSubmitModalOpenChange}
        onConfirm={async () => {
          try {
            switch (userRole) {
              case ApproverLevel.APPROVER_L1:
                switch (stringToTicketPhase(ticketData.phase)) {
                  case TicketPhase.Proposal: {
                    const hasReject = hasRejectedSubTicket({
                      ticketDataArray: ticketData.sub_tickets,
                      phase: TicketPhase.Proposal,
                    });
                    if (hasReject) {
                      await handleRejectProposalTicket();
                    } else {
                      await handleAcceptProposalTicket();
                    }

                    break;
                  }
                  case TicketPhase.Claim: {
                    const hasReject = hasRejectedSubTicket({
                      ticketDataArray: ticketData.sub_tickets,
                      phase: TicketPhase.Claim,
                    });
                    if (hasReject) {
                      await handleRejectClaimTicket();
                    } else {
                      const assignApprover = () => {
                        switch (ticketData.brand) {
                          case TicketBrands.BYD:
                            return "allPhase";
                          case TicketBrands.Denza:
                            return "allPhase_Denza";
                        }
                      };

                      const isAlreadyApprover = findAssignApprover(
                        ticketData.id,
                        {
                          type: assignApprover(),
                        }
                      );

                      if (isAlreadyApprover) {
                        await handleAcceptClaimTicket();
                      } else {
                        await handleL1AcceptClaimTicket();
                      }
                    }
                    break;
                  }
                  case TicketPhase.Accounting:
                    await handleAcceptAccountingTicket();
                    break;
                }
                break;
              case ApproverLevel.APPROVER_L2:
                switch (stringToTicketPhase(ticketData.phase)) {
                  case TicketPhase.Proposal:
                    await handleAcceptProposalTicket();
                    break;
                  case TicketPhase.Claim: {
                    const hasReject = hasRejectedSubTicket({
                      ticketDataArray: ticketData.sub_tickets,
                      phase: TicketPhase.Claim,
                    });

                    if (hasReject) {
                      await handleRejectClaimTicket();
                    } else {
                      await handleAcceptClaimTicket();
                    }
                    break;
                  }
                }
                break;
              case ApproverLevel.APPROVER_L3:
                switch (stringToTicketPhase(ticketData.phase)) {
                  case TicketPhase.Proposal:
                    await handleAcceptProposalTicket();
                    break;
                  case TicketPhase.Claim: {
                    const hasReject = hasRejectedSubTicket({
                      ticketDataArray: ticketData.sub_tickets,
                      phase: TicketPhase.Claim,
                    });
                    if (hasReject) {
                      await handleRejectClaimTicket();
                    } else {
                      await handleAcceptClaimTicket();
                    }
                    break;
                  }
                }
                break;
              case ApproverLevel.APPROVER_L4:
                switch (stringToTicketPhase(ticketData.phase)) {
                  case TicketPhase.Management: {
                    const hasReject = hasRejectedSubTicket({
                      ticketDataArray: ticketData.sub_tickets,
                      phase: TicketPhase.Management,
                    });
                    await handleAcceptManagementTicket();
                    break;
                  }
                  case TicketPhase.Accounting:
                    await handleAcceptAccountingTicket();
                    break;
                }
                break;
              case ApproverLevel.APPROVER_L5:
                switch (stringToTicketPhase(ticketData.phase)) {
                  case TicketPhase.Management: {
                    const hasReject = hasRejectedSubTicket({
                      ticketDataArray: ticketData.sub_tickets,
                      phase: TicketPhase.Management,
                    });
                    await handleAcceptManagementTicket();
                    break;
                  }
                }
                break;
            }
            setIsSkipApproverValidate(false);
            setSelectSubTicket(null);
            AppUtility.refreshPage();
          } catch (e) {
            void e;
          }
        }}
      />
    </>
  );
};

ApproverTicketTile.propTypes = {
  ticketData: TicketPropsInterface,
};

export default ApproverTicketTile;
